import type { StoredState } from '../types/model';
import type { DataApi } from './types';
import { loadStoredState, persistStoredStateWithKey } from '../utils/storage';

type FakeApiOptions = {
  storageKey?: string;
  delayMs?: number;
};

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export class FakeApi implements DataApi {
  private storageKey: string;
  private delayMs: number;

  constructor(options: FakeApiOptions = {}) {
    this.storageKey = options.storageKey ?? 'visual-data-modeler-state';
    this.delayMs = options.delayMs ?? 120;
  }

  async loadState(): Promise<StoredState | null> {
    if (this.delayMs > 0) {
      await delay(this.delayMs);
    }
    return loadStoredState(this.storageKey);
  }

  async saveState(state: StoredState): Promise<void> {
    if (this.delayMs > 0) {
      await delay(this.delayMs);
    }
    persistStoredStateWithKey(state, this.storageKey);
  }
}
